// extracted by mini-css-extract-plugin
export default {"arrowIcon":"z3SJ3E"};